import type { WorkflowProps } from 'flow/store/engine/types';
import { formatColor } from 'flow/editor/components/helpers';
import { getOutcomeBaseColor } from 'flow/service/actions';
import {
  getOutcomeIconName,
} from '~/dashboard/views/workflows/editor/components/Island/OutcomeIsland/OnIslandOutcomeNode/helpers';
import type { Outcome } from '~/entities/types';

import { OutcomeIcon } from './OutcomeIcon';
import type { OutcomeOption } from './types';


// FIXME: BUILD-654 - centralize these helpers
export function buildOutcomeOption({
  outcome,
  namesOfOutcomesInWorkflow,
}: {
  outcome: Outcome;
  namesOfOutcomesInWorkflow: Set<String>;
}): OutcomeOption {
  const outcomeName = outcome.outcome;
  const colorToUse = outcome.outcome_color
    ? outcome.outcome_color
    : getOutcomeBaseColor(outcomeName);
  const icon = outcome.icon_name
    ? outcome.icon_name
    : getOutcomeIconName(outcomeName);
  const color = formatColor(colorToUse);

  return {
    // FIXME: BUILD-1368
    disabled: namesOfOutcomesInWorkflow.has(outcome.outcome),
    icon: (
      <OutcomeIcon
        color={color}
        icon={icon}
      />
    ),
    label: outcomeName,
    meta: { color, icon },
    value: outcomeName,
    // @ts-expect-error - the two keys below are E2E testing anchors
    'data-value': outcomeName,
    'data-testid': outcomeName,
  };
}

export function buildOutcomeOptions({
  outcomes,
  namesOfOutcomesInWorkflow,
}: {
  outcomes: WorkflowProps['outcomes'];
  namesOfOutcomesInWorkflow: Set<String>;
}): OutcomeOption[] {
  return outcomes.map(outcome => buildOutcomeOption({
    outcome,
    namesOfOutcomesInWorkflow,
  }));
}
